<section class="dashboard_content_sec my_bid_sec enquiries_sec">
  <div class="my_supplies_listing">
    <!-- TABLE-LISTING -->
    <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
      fxLayoutAlign="start stretch" fxLayoutGap="15px">
      <div fxLayout="column" fxFlex="100" fxFlexFill>
        <!-- tables-section -->
        <section class="table_section">
          <div class="custom-sticky-table" fxLayout="column" fxLayoutAlign="start stretch">

              <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
                <!-- Position Column -->
                <ng-container matColumnDef="sNo">
                  <th mat-header-cell *matHeaderCellDef>S.No</th>
                  <td mat-cell *matCellDef="let element;let i = dataIndex" data-label="S.No"> {{ i+1 }} </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="title">
                  <th mat-header-cell *matHeaderCellDef> Product Name</th>
                  <td mat-cell *matCellDef="let element"  data-label="Product Name">
                    <a [routerLink]="['/second-hand-supplies/details', element.id]"> {{element.title}} </a>
                  </td>
                </ng-container>
                <!-- Bid Price Column -->
                <ng-container matColumnDef="bid_starts_at">
                  <th mat-header-cell *matHeaderCellDef> Bid Starts At </th>
                  <td mat-cell *matCellDef="let element"  data-label="Bid Starts At">
                    {{element.bid_starts_at}}
                  </td>
                </ng-container>
                <!-- Bid Price Column -->
                <ng-container matColumnDef="bid_ends_at">
                  <th mat-header-cell *matHeaderCellDef>Bid End Date</th>
                  <td mat-cell *matCellDef="let element" data-label="Bid End Date">
                    {{element.bid_starts_at}}
                  </td>
                </ng-container>
                <!-- Bid Price Column -->
                <ng-container matColumnDef="sku">
                  <th mat-header-cell *matHeaderCellDef>SKU No</th>
                  <td mat-cell *matCellDef="let element" data-label="SKU No">
                    {{element.sku}}
                  </td>
                </ng-container>
                <!-- Bid Price Column -->
                <ng-container matColumnDef="check_out">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element" data-label="Action">
                    <button type="button"  mat-button *ngIf="element.status === 'COMPLETED' && (
                      element.winner_dental_practice_id === loginData.id ||
                      element.winner_dental_professional_id === loginData.id ||
                      element.winner_dental_supplier_id === loginData.id)" (click)="checkout($event, element.id)"
                      class="btn btn-sm global-btn table_btn" style="
                      padding: 0 10px 3px 10px!important;
                  "> Checkout </button>
                  </td>
                </ng-container>
                <!-- Bid Price Column -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                  <td mat-cell *matCellDef="let element">
                    <img src="../../../../../assets/images/icons/table_down.svg" alt="">
                    <!-- <button type="button" *ngIf="element.status === 'COMPLETED' && (
                      element.winner_dental_practice_id === loginData.id ||
                      element.winner_dental_professional_id === loginData.id ||
                      element.winner_dental_supplier_id === loginData.id)" (click)="checkout($event, element.id)"
                      class="btn btn-sm global-btn table_btn" mat-button> Checkout </button> -->
                  </td>
                </ng-container>
                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div class="example-element-detail"
                      [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                      <div class="w-100" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                        fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="15px">
                        <!-- <div fxLayout="column" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="25" fxFlex.sm="25" fxFlex.xs="100" fxFlexFill></div> -->
                        <div fxLayout="column" fxFlex.xl="85" fxFlex.lg="85" fxFlex.md="85" fxFlex.sm="85"
                          fxFlex.xs="100" fxFlexFill>
                          <table class="inner_table">
                            <thead>
                              <th>S.No</th>
                              <th> Bid date time</th>
                              <th> Price </th>
                              <th> Message </th>
                            </thead>
                            <tbody>
                              <tr *ngFor="let singleBid of element.second_hand_supplies_bids; let i = index">
                                <td class="table_width_50">{{i+1}}</td>
                                <td class="table_width">{{singleBid.created_at | date: "dd-MM-yyyy hh:mm:ss"}}</td>
                                <td class="table_width_130">AUD {{singleBid.price.toFixed(2)}}</td>
                                <td>{{singleBid.message}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="loading">
                  <th mat-footer-cell *matFooterCellDef colspan="8">
                    <div class="custom-loader ">
                      <div class="custom-loader custom_logo_loader">
                        <img src='../../../../../images2/loader.gif' alt="img" loading="lazy" />
                      </div>
                    </div>
                  </th>
                </ng-container>
                <ng-container matColumnDef="noData">
                  <th mat-footer-cell *matFooterCellDef colspan="8" class="no-data empty-img">
                    <div class="no-data empty-img">
                      <!-- EMPTY-STATE -->
                      <img src='../../../../../../../assets/images/empty-imgs/no_bids.svg' alt="img" loading="lazy" />
                      <h4 class="no_state_heading">No BID's</h4>
                    </div>
                  </th>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
                  [class.example-expanded-row]="expandedElement === element"
                  (click)="expandedElement = expandedElement === element ? null : element">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ hide: dataSource != null }"></tr>
                <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{hide: !( dataSource != null && dataSource.filteredData.length == 0)
            }"></tr>
              </table>

          </div>
          <!-- TABLE-PAGINATOR -->
          <div fxLayout="column" fxLayout.lg="column" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column"
            fxFlexFill fxLayoutGap="8px">
            <mat-paginator [length]="totalElements" [pageSize]="limit.value" (page)="changePage($event)">
            </mat-paginator>
          </div>
        </section>
      </div>
    </div>
  </div>
</section>
